import * as React from 'react';
import { forwardRef } from 'react';
import type { Ref } from 'react';

import type { IconProps } from '../../Icon';
import { Icon } from '../../Icon';
function SvgStorefrontIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.52 2.3a.75.75 0 0 1 .6-.3h7.76a.75.75 0 0 1 .6.3l2.37 3.158a.75.75 0 0 1 .15.45v.842c0 .04-.003.077-.009.115A2.311 2.311 0 0 1 14 8.567v5.683a.75.75 0 0 1-.75.75H2.75a.75.75 0 0 1-.75-.75V8.567A2.311 2.311 0 0 1 1 6.75v-.841a.75.75 0 0 1 .15-.45l2.37-3.16Zm7.605 6.068c.368.337.847.557 1.375.6V13.5h-9V8.968a2.303 2.303 0 0 0 1.375-.6c.411.377.96.607 1.563.607.602 0 1.15-.23 1.562-.607.411.377.96.607 1.563.607.602 0 1.15-.23 1.562-.607Zm2.375-2.21v.532l-.001.019a.813.813 0 0 1-1.623 0 .754.754 0 0 0-.008-.076.756.756 0 0 0 .012-.133V4L13.5 6.16Zm-3.113.445a.762.762 0 0 0-.013.106.813.813 0 0 1-1.624-.019V3.5h1.63v3c0 .035.002.07.007.103ZM7.25 3.5v3.19a.813.813 0 0 1-1.624.019.757.757 0 0 0-.006-.064V3.5h1.63ZM4.12 4 2.5 6.16v.531l.001.019a.813.813 0 0 0 1.619.045V4Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const StorefrontIcon = forwardRef((props: IconProps, forwardedRef?: Ref<HTMLSpanElement>) => {
  return <Icon ref={forwardedRef} {...props} component={SvgStorefrontIcon} />;
});
StorefrontIcon.displayName = 'StorefrontIcon';
export default StorefrontIcon;
